import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';

export interface IWhitelistState {
  readonly blockedSites: boolean;
  readonly workMode: boolean;
}

const initialState: IWhitelistState = {
  blockedSites: false,
  workMode: false,
};

const whitelistSlice = createSlice({
  name: SLICE_NAMES.WHITELIST,
  initialState,
  reducers: {
    setWhitelist: (_state, action: PayloadAction<IWhitelistState>) => {
      return action.payload;
    },
  },
});

export const { setWhitelist } = whitelistSlice.actions;

export const whitelistReducer = whitelistSlice.reducer;
